import { Component } from '@angular/core';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { TechnicalSpecificationsFormSections } from '../../../entities/enums/ui-collection-types.enum';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-feed-in-type',
  templateUrl: './feed-in-type.component.html',
  styleUrls: ['./feed-in-type.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FeedInTypeComponent extends BaseTechnicalSectionComponent {
  constructor(commentService: GridApplicationCommentsService, environmentService: EnvironmentService) {
    super(commentService, environmentService);
  }

  public resetFeedInType(): void {
    this.technicalData.type_of_complete_feed_in = null;
  }

  get formSection(): TechnicalSpecificationsFormSections {
    return TechnicalSpecificationsFormSections.TypeOfFeedIn;
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.type_of_feed_in_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.type_of_feed_in_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_type_of_feed_in_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_type_of_feed_in_locked = value;
  }
}
